import React, { MouseEventHandler } from "react";

import { Box } from "../../../../../../../layout";
import MenuItemContents from "../components/MenuItemContents/MenuItemContents";
import { MenuItemChildren } from "../types";
import useMenuItemStyles from "../utils/useMenuItemStyles";

type MenuButtonProps = {
  children: MenuItemChildren;
  onClick: MouseEventHandler;
  disabled?: boolean;
  ariaLabel?: string;
};

export default function ContextMenuButton(props: MenuButtonProps) {
  const { children, onClick, disabled = false, ariaLabel } = props;

  const styles = useMenuItemStyles(disabled);

  return (
    <Box
      component="button"
      className="focus-malibu"
      aria-label={ariaLabel}
      onClick={onClick}
      disabled={disabled}
      {...styles}
    >
      <MenuItemContents disabled={disabled}>{children}</MenuItemContents>
    </Box>
  );
}
